import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetBadRateInfo($id: ID!) {
    chat(id: $id) {
      id
      user {
        id
        email
      }
      expert {
        id
        name
        photoUrl
      }
    }
  }
`);
